import { Button } from "@chakra-ui/react";
import React, { useState } from "react";
import { useEffect } from "react";
import {useNavigate, useSearchParams } from "react-router-dom";

const Filter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialParams = searchParams.getAll("category");
  const [category, setCategory] = useState(initialParams || []);
  const navigate = useNavigate();

  const hanldeonChange = (e) => {
    const option = e.target.value;
    let newCategory = [...category];
    if (category.includes(option)) {
      newCategory.splice(newCategory.indexOf(option), 1);
    } else {
      newCategory.push(option);
    }
    setCategory(newCategory);
  };
  useEffect(() => {
    if (category) {
      setSearchParams({ category: category });
    }
  }, [category, setSearchParams]);
  const handleFundraiser = () => {
    navigate("/medical",{replace:true})
  }
  return (
    <div style={{ padding: "10px" }}>
      <h2 style={{fontWeight: "bold",textAlign: "center"}}>CATEGORIES</h2>
      <br/>
      <hr></hr>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Education"
          defaultChecked={category.includes("Education")}
          onChange={hanldeonChange}
        />
        <label>Education</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Medical"
          defaultChecked={category.includes("Medical")}
          onChange={hanldeonChange}
        />
        <label>Medical</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Women & Girls"
          defaultChecked={category.includes("Women & Girls")}
          onChange={hanldeonChange}
        />
        <label>Women & Girls</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Animals"
          defaultChecked={category.includes("Animals")}
          onChange={hanldeonChange}
        />
        <label>Animals</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Creative"
          defaultChecked={category.includes("Creative")}
          onChange={hanldeonChange}
        />
        <label>Creative</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Food & Hunger"
          defaultChecked={category.includes("Food & Hunger")}
          onChange={hanldeonChange}
        />
        <label>Food & Hunger</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Environment"
          defaultChecked={category.includes("Environment")}
          onChange={hanldeonChange}
        />
        <label>Environment</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Children"
          defaultChecked={category.includes("Children")}
          onChange={hanldeonChange}
        />
        <label>Children</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Memorial"
          defaultChecked={category.includes("Memorial")}
          onChange={hanldeonChange}
        />
        <label>Memorial</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Community Development"
          defaultChecked={category.includes("Community Development")}
          onChange={hanldeonChange}
        />
        <label>Community Development</label>
      </div>
      <div style={{ padding: "10px" }}>
        <input
          type="checkbox"
          value="Others"
          defaultChecked={category.includes("Others")}
          onChange={hanldeonChange}
        />
        <label>Others</label>
      </div>
      <hr />
      <br/>
      <Button backgroundColor="#01BFBD"  marginLeft="40px" onClick={handleFundraiser}>Start Fundraiser</Button>
    </div>
  );
};

export default Filter;
